import {React, useState, useEffect} from "react";
import {Col, DatePicker, Row, Flex, Tooltip, Button, Typography, theme} from 'antd';
import {LeftOutlined, RightOutlined} from '@ant-design/icons';
import ImageSign from './components/ImageSign';
import SignTag from "./components/signTag";
import maya from './js/maya';
import dayjs from 'dayjs';

const { Title, Paragraph, Text, Link } = Typography;
const TzolkinMain = (props) => {
    const {
        token: {colorBgContainer, borderRadiusLG}
    } = theme.useToken();
    useEffect(() => {
        const track_keyboard = (e) => {
            if(e.code =="ArrowLeft") backDay();
            else if(e.code == "ArrowRight") nextDay();
        }
        document.body.addEventListener('keydown', track_keyboard);
        return () => {
            document.body.removeEventListener('keydown', track_keyboard);
        }
    })
    const nextDay = () => setCurrentDate(maya.nextDay(currentDate.date));
    const backDay = () => setCurrentDate(maya.backDay(currentDate.date))
    var currentDate = maya.maya(props.date);
    var setCurrentDate = props.setDate;
    var selectSign = props.selectSign;
    const dateChange = (date) => {
        if(date) {
            setCurrentDate(new Date(date.format("YYYY-MM-DD")));
        } else {
            setCurrentDate(new Date());
        }
    }
    return (<Flex gap="large" justify="space-between" align="center" vertical style={{
            minHeight: '700px',
            minWidth: '300px',
            margin: '1em',
            borderRadius: '2em',
            backgroundColor: colorBgContainer}}
            title={props.locale.longcount}>
        <Typography.Text>{currentDate.longcountAll}</Typography.Text>

        <Typography.Text>{props.locale.kin} {currentDate.kin}</Typography.Text>

        <Flex gap="0.5em" horizontal align="center" justify="center">
            <Flex vertical align="flex-end" onClick={() => selectSign(currentDate.daysign)}>
                <ImageSign width="50%" sign={currentDate.daysign}/>
                <Typography.Text>{props.locale.signs[currentDate.daysign]}</Typography.Text>
            </Flex>
            <Flex vertical align="flex-start" onClick={() => selectSign(currentDate.trecena)}>
                <ImageSign width="50%" sign={currentDate.trecena}/>
                <Typography.Text>{props.locale.signs_to[currentDate.trecena]}</Typography.Text>
            </Flex>
        </Flex>

        <Flex gap="4px 0" wrap horizontal align="center" justify="center" style={{height: "5em"}}>
            {currentDate.fantoms.map(fantom => {
                return (<SignTag locale={props.locale} title={props.locale.phantom+" "+props.locale.signs[fantom]} onClick={() => selectSign(fantom)} sign={fantom}/>)
            })}
            {currentDate.fantoms.length == 0? props.locale.phantom_empty:""}
        </Flex>

        <Flex horizontal align="flex-end" justify="center">
            <Tooltip title={props.locale.back_day}><Button onClick={backDay} icon={<LeftOutlined/>}/></Tooltip>
            <DatePicker value={dayjs(currentDate.date)} onChange={dateChange}/>
            <Tooltip title={props.locale.next_day}><Button onClick={nextDay} icon={<RightOutlined/>}/></Tooltip>
        </Flex>
    </Flex>)
}

export default TzolkinMain;